/**
 * In-Memory-Vault-State (KEK + Auto-Lock).
 *
 * - KEK ist ein `CryptoKey` (nicht extractable) und lebt nur im JS-Heap.
 * - Auto-Lock nach `AUTO_LOCK_MS` Inaktivität.
 * - Beim Logout & beim Page-Unload wird der State weggeworfen.
 */
import { create } from "zustand";

const AUTO_LOCK_MS = 5 * 60 * 1000; // 5 Minuten

interface VaultState {
  kek: CryptoKey | null;
  lastActivity: number;
  setKek: (kek: CryptoKey) => void;
  lock: () => void;
  touch: () => void;
  startAutoLock: () => void;
}

let autoLockTimer: ReturnType<typeof setInterval> | null = null;

export const useVaultStore = create<VaultState>((set, get) => ({
  kek: null,
  lastActivity: 0,
  setKek: (kek) => set({ kek, lastActivity: Date.now() }),
  lock: () => set({ kek: null, lastActivity: 0 }),
  touch: () => set({ lastActivity: Date.now() }),
  startAutoLock: () => {
    if (autoLockTimer !== null) return;
    autoLockTimer = setInterval(() => {
      const { kek, lastActivity, lock } = get();
      if (kek && Date.now() - lastActivity > AUTO_LOCK_MS) {
        lock();
      }
    }, 30_000);
  },
}));

if (typeof window !== "undefined") {
  window.addEventListener("beforeunload", () => useVaultStore.getState().lock());
}
